import React, { useEffect, useMemo } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useTranslation } from "react-i18next";
import { createAppTheme } from "./theme";

/**
 * Theme provider that switches font based on language:
 * - English: Roboto
 * - Dari/Pashto: Noto Sans Arabic (Perso-Arabic script)
 * All fonts are loaded offline via @fontsource.
 */
const AppThemeProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const direction =
    i18n.language === "en" || !i18n.language ? "ltr" : "rtl";

  const theme = useMemo(() => createAppTheme(direction), [direction]);

  useEffect(() => {
    document.body.setAttribute("dir", direction);
    localStorage.setItem("direction", direction);
  }, [direction]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
